import React, { useContext, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateWarningsModal } from "@features/modalSlice";
import { mainContext } from "@ts/constants";
import WarningsModal from "./WarningsModal";
import { IMainContext } from "@ts/common-types";

type TRefreshTokenMetaData = {
    refreshTokenMetaData: {
        value: {
            exp: number,
            iat: number,
            jti: string,
        }

    }
}

const ExpiryTimeCalculator = React.memo(() => {
    const {
        currentTime,
        setSessionExpiredAlert,
    } = useContext<IMainContext>(mainContext);

    const refreshTokenMetaData = useSelector((state: TRefreshTokenMetaData) => state.refreshTokenMetaData.value)

    const refreshTokenExptime = useMemo(() => {
        return refreshTokenMetaData.exp - refreshTokenMetaData.iat;
    }, [refreshTokenMetaData]);

    const [expiryTime, setExpiryTime] = useState(
        refreshTokenMetaData.exp - currentTime
    );
    const dispatch = useDispatch();
    const clientIdleSessionLimit = Number(
        process.env.VITE_CLIENT_IDLE_SESSION_LIMIT || 1200
    );
    const timerLimit = 1000;

    useEffect(() => {
        const interval = setInterval(() => {
            setExpiryTime((prev: number) => prev - 1);
        }, timerLimit);
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        setExpiryTime(refreshTokenMetaData.exp - currentTime);
        // eslint-disable-next-line
    }, [refreshTokenMetaData]);

    useEffect(() => {
        if (
            expiryTime ===
            Number(process.env.VITE_SESSION_TIMER_INTIAL_VALUE || 300)
        ) {
            if (refreshTokenExptime < clientIdleSessionLimit) {
                setSessionExpiredAlert(true);
            }
            dispatch(updateWarningsModal(true));
        }
        // eslint-disable-next-line
    }, [expiryTime, dispatch]);
    return (
        <>
            <WarningsModal expiryTime={expiryTime} />
        </>
    );
});

export default ExpiryTimeCalculator;
